import {
  AddUserToOrganizationOperationRequest,
  AddUserToOrganizationRequest,
} from "@revolutionrobotics/admin-api";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { OrganizationApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { FormItem } from "../FormItem";

interface AddUserFormProps {
  setLoading: Function;
  setError: Function;
  refresh: Function;
  id?: string;
}

export function AddUserForm({
  setLoading,
  setError,
  refresh,
  id,
}: AddUserFormProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    addUserToOrganization();
  };

  const addUserToOrganization = () => {
    console.log("addUser()");

    if (!id || !inputs.codeName) {
      return;
    }
    setLoading(true);

    const details: AddUserToOrganizationRequest = {
      codeName: inputs.codeName,
    };

    const req: AddUserToOrganizationOperationRequest = {
      request: details,
      id: id,
    };

    OrganizationApi.addUserToOrganization(req)
      .then(
        () => {
          console.log("user has been add to organization.");
        },
        (error) => {
          setLoading(false);
          SetError(error, setError);
        }
      )
      .finally(() => {
        setLoading(false);
        refresh();
      });
  };

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row className="mt-2">
            <FormItem
              title={"Code Name"}
              type={"text"}
              required={true}
              name={"codeName"}
              handleChange={handleChange}
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
